import * as React from "react";
import { CheckedDrawing, UncheckedDrawing, CheckboxWrapper } from "./checkbox-list-item-style";
import { withTheme } from "styled-components";
import type { RuntimeTheme } from "../../../lib/theme/theme";
import { isEmptyOrUndefined } from "common/Support";

interface Props {
    checked: boolean;
    onChanged: (newValue: boolean) => void;
    isEnabled: boolean;
    theme: RuntimeTheme;
    className?: string;
    title?: string;
    description?: string;
}

class CheckboxListItem extends React.PureComponent<Props> {
    public render(): React.ReactNode {
        const { isEnabled, checked, title, description, className, onChanged, theme } = this.props;
        const Image = checked ? CheckedDrawing : UncheckedDrawing;
        const titleOnly = !isEmptyOrUndefined(title) && isEmptyOrUndefined(description);
        const descriptionOnly = isEmptyOrUndefined(title) && !isEmptyOrUndefined(description);
        const singleItem = titleOnly || descriptionOnly;

        return (
            <CheckboxWrapper
                className={className}
                data-test="app-checkbox-list-item"
                isEnabled={isEnabled}
                checked={checked}
                singleItem={singleItem}>
                <input type="checkbox" checked={checked} onChange={() => onChanged(!checked)} />
                <Image theme={theme} />
                <div className="text-wrapper">
                    <div className="title">{title}</div>
                    <div className="description">{description}</div>
                </div>
            </CheckboxWrapper>
        );
    }
}

export default withTheme(CheckboxListItem);
